'use client';
import React, { useEffect } from 'react';
import styles from './base.module.scss';
import { __BasePropsType } from './base.type';
import BottomNavigationComp from './bottomNavigation/bottomNavigation.index';
import FooterComp from './footer/footer.index';
import HeaderComp from './header/header.index';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const BaseComp: React.FC<React.PropsWithChildren<__BasePropsType>> = (
    props: React.PropsWithChildren<__BasePropsType>,
) => {
    useEffect(() => {
        document.addEventListener('contextmenu', eventHandler);
        return () => {
            document.removeEventListener('contextmenu', eventHandler);
        };
    }, []);

    function eventHandler(event: MouseEvent) {
        if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            event.preventDefault();
    }

    return (
        <>
            {props.noLayout ? null : (
                <HeaderComp
                    showHeaderInMobile={props.showHeaderInMobile}
                    headerBgDarkInLightMode={props.headerBgDarkInLightMode}
                    search={props.search}
                    noLocation={props.noLocation}
                    hasBackButton={props.hasBackButton}
                />
            )}
            <main
                className={`${styles['container']} flex-column 
                    ${props.noLayout ? styles['no-layout'] : props.showHeaderInMobile ? styles['mobile-header'] : ''} 
                    ${props.noLayout ? '' : props.hideBottomNavigation ? styles['no-btm-nav'] : ''}`}
            >
                <div className="main-content w-100 flex-column flex-1">{props.children}</div>
            </main>
            {props.noLayout ? null : <FooterComp />}
            {!props.noLayout && !props.hideBottomNavigation ? <BottomNavigationComp /> : null}
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </>
    );
};

export default BaseComp;
